import {
    Card,
    CardAccountType,
    CardActivation,
    CardStatus,
    CardType,
    CardVendor,
    OrderCardStatus,
} from '@generated-types';

export const debitCard1Mock: Card = {
    id: 'MjM1MTEzMDM0xIJfNDI5OTQxKsSRxJI3MTAyXzFfMDk4MTc2OTbEnjlfREVCSVQ=',
    accountId: 'MjM1MTEzMDM0xIJfMDk4MTc2OTbEjjk=',
    bankRegistrationNumber: '2351',
    accountNumber: '23511303451',
    number: '429941xxxxxx7102',
    version: 1,
    expirationDate: {
        month: 2,
        year: 28,
    },
    accountOwner: '09817696179',
    owner: '09817696179',
    embossedName: 'ØKOLOGISK DRAGE',
    embossedName2: '',
    imagePath: 'https://skuesparebank.test.eika.no//-/media/fellesbilder/kortdesign/debetkort/2351.png',
    vendor: CardVendor.VISA,
    product: {
        code: 'BANKKORT_VOKSEN',
        id: 12601,
        key: 'PRIVATEEIKA',
        name: 'Bankkort Voksen',
    },
    market: 'PRIVATE' as Card['market'],
    type: CardType.DEBIT,
    orderStatus: OrderCardStatus.ORDERED,
    status: CardStatus.OK,
    block: undefined,
    created: new Date('2025-02-18'),
    activation: CardActivation.ACTIVE,
    allowedOperations: {
        softBlock: true,
        hardBlock: true,
        delete: true,
        unblock: false,
        reorder: false,
        getVirtualCard: true,
        getPin: true,
        setPin: true,
        getRule: true,
        setRule: true,
        getOnlineSpending: true,
        setOnlineSpending: true,
        getSpendingLimit: true,
        setSpendingLimit: false,
        getMyDisputes: true,
        setWallets: true,
        activateCard: false,
        getLoyalty: false,
        setLoyalty: false,
        setCancellation: false,
        migrationWeekStart: false,
        migrationWeekEnd: false,
    },
    accountType: CardAccountType.DEBIT,
};
